/* eslint-disable max-len */
import React, { useCallback, useState } from 'react';
import { Host } from '../../Host';
import { CommandDispatcher } from '../../concepts/commands/CommandDispatcher';
import { ClipDataBuilder, ClipboardService } from '../../platform/Clipboard';
import { Menu } from '../../ui';
import { DropMenuButton } from '../../ui/MenuButton';
import { useResolve } from '../Container';
import { useFeatureCheck } from '../common/FeatureElements';
import { Flexer } from '../dashboard/elements/LayoutElements';
import { boardClone, boardDelete, boardMove, boardRename } from '../workspace/BoardCommands';

export type AllBoardsActionMenuProps = {
    board: { id: string, path: string },
    editOpts: 'show' | 'disable' | 'hide',
};

export const AllBoardsActionMenu = React.memo<AllBoardsActionMenuProps>(({ board, editOpts }) => {

    const clipboard = useResolve(ClipboardService);
    const dispatch = useResolve(CommandDispatcher);
    const workspacesEnabled = useFeatureCheck('workspaces');
    const [open, setOpen] = useState(false);

    const onCopyLink = useCallback(() => {
        const data = new ClipDataBuilder();
        data.setText(Host.absUrl(board.path));
        clipboard.write(data.build());
    }, [board.path]);

    const close = () => {
        setOpen(false);
        return true;
    };

    return <Flexer margin="0 .5">
        <DropMenuButton icon="deqo://icons/hero/dots-horizontal" open={open} setOpen={setOpen}>
            <Flexer minWidth="10">
                <Menu>
                    <Menu.Item onClick={() => close() && onCopyLink()}>
                        <Menu.ItemText>Copy Link</Menu.ItemText>
                    </Menu.Item>
                    {editOpts !== 'hide' && <>
                        <Menu.Divide />
                        <Menu.Item disabled={editOpts === 'disable'} onClick={() => close() && dispatch(boardRename, [board.id])}>
                            <Menu.ItemText>Rename</Menu.ItemText>
                        </Menu.Item>
                        {workspacesEnabled && <Menu.Item disabled={editOpts === 'disable'} onClick={() => close() && dispatch(boardMove, [board.id])}>
                            <Menu.ItemText>Move</Menu.ItemText>
                        </Menu.Item>}
                        <Menu.Item disabled={editOpts === 'disable'} onClick={() => close() && dispatch(boardClone, [board.id])}>
                            <Menu.ItemText>Clone</Menu.ItemText>
                        </Menu.Item>
                        <Menu.Divide />
                        <Menu.Item disabled={editOpts === 'disable'} onClick={() => close() && dispatch(boardDelete, [board.id])}>
                            <Menu.ItemText>Delete</Menu.ItemText>
                        </Menu.Item>
                    </>}
                </Menu>
            </Flexer>
        </DropMenuButton>
    </Flexer>;
});
